import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RentalPropertyAnalyzer from './RentalPropertyAnalyzer';
import LoginPage from './components/auth/LoginPage';
import SignupPage from './components/auth/SignupPage';
import ResetPassword from './components/auth/ResetPassword';
import CompletePasswordResetPage from './components/auth/CompletePasswordResetPage';
import AuthActionRedirect from './components/auth/AuthActionRedirect';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';
import ShareViewGate from './components/shared/ShareViewGate';
import ErrorBoundary from './components/ErrorBoundary';
import FeedbackAdminPage from './components/feedback/FeedbackAdminPage';
import ImpersonatePage from './components/admin/ImpersonatePage';
import ImpersonationBanner from './components/admin/ImpersonationBanner';
import PendingApprovalGate from './components/auth/PendingApprovalGate';
import AccountApprovalsAdminPage from './components/admin/AccountApprovalsAdminPage';
import LegalDocumentPage from './components/legal/LegalDocumentPage';

function App() {
  return (
    <ShareViewGate>
      <AuthActionRedirect />
      <ImpersonationBanner />
      <Routes>
        <Route
          path="/"
          element={
            <ErrorBoundary>
              <ProtectedRoute>
                <PendingApprovalGate>
                  <RentalPropertyAnalyzer />
                </PendingApprovalGate>
              </ProtectedRoute>
            </ErrorBoundary>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/terms" element={<LegalDocumentPage doc="terms" />} />
        <Route path="/privacy" element={<LegalDocumentPage doc="privacy" />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/complete-password-reset" element={<CompletePasswordResetPage />} />
        <Route
          path="/admin/feedback"
          element={
            <ErrorBoundary>
              <ProtectedRoute>
                <AdminRoute>
                  <FeedbackAdminPage />
                </AdminRoute>
              </ProtectedRoute>
            </ErrorBoundary>
          }
        />
        <Route
          path="/admin/impersonate"
          element={
            <ErrorBoundary>
              <ProtectedRoute>
                <AdminRoute>
                  <ImpersonatePage />
                </AdminRoute>
              </ProtectedRoute>
            </ErrorBoundary>
          }
        />
        <Route
          path="/admin/account-approvals"
          element={
            <ErrorBoundary>
              <ProtectedRoute>
                <AdminRoute>
                  <AccountApprovalsAdminPage />
                </AdminRoute>
              </ProtectedRoute>
            </ErrorBoundary>
          }
        />
      </Routes>
    </ShareViewGate>
  );
}

export default App;
